export enum HttpCode {
  NeedUserLogin = 602,
  NeedUserLogin2 = 603,
  UnknownError = 100,
  LinkWorkerError = 500,
  NotAllowed = 403,
  FileShareExpired = 1203,
  FileShareNotFound = 1202,
}
